// Global Enums for the application

export const NotificationType = Object.freeze({
  NOTIFICATION_CATEGORY: 'NOTIFICATION_CATEGORY',
  NOTIFICATION_UNREGISTERED_ACTIVATION: 'NOTIFICATION_UNREGISTERED_ACTIVATION',
  NOTIFICATION_REGISTERED_ACTIVATION: 'NOTIFICATION_REGISTERED_ACTIVATION',
  NOTIFICATION_PASSIVED_REGISTERED_ACTIVATION: 'NOTIFICATION_PASSIVED_REGISTERED_ACTIVATION',
});

// Helper function to get enum values as array
export const getEnumValues = (enumObject) => {
  return Object.values(enumObject);
};

// Helper function to get enum keys as array
export const getEnumKeys = (enumObject) => {
  return Object.keys(enumObject);
};

// Helper function to check if a value exists in enum
export const isValidEnumValue = (enumObject, value) => {
  return Object.values(enumObject).includes(value);
};
